export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50 mb-4 block">
              羞羞动漫
            </span>
            <p className="text-sm text-background-50/60 leading-relaxed">
              羞羞动漫在线蜜桃系列高清完整版，提供羞羞动漫在线观看、免费播放与新番追更服务。动漫美女爆羞羞动漫在线蜜桃一网打尽，下拉式流畅体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a>
              <a href="#cards" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#ranking" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
              <a href="#carousel" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <div className="space-y-2">
              <a href="#topics" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">校园恋爱</a>
              <a href="#topics" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">奇幻冒险</a>
              <a href="#topics" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">恋爱甜宠</a>
              <a href="#topics" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">新番热映</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关于本站
            </h4>
            <div className="space-y-2">
              <a href="#about" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#features" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">本站特色</a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 mb-8">
          <h4 className="font-heading text-sm font-semibold text-background-50/50 mb-4 text-center">
            合作伙伴
          </h4>
          <p className="text-xs text-background-50/30 text-center">
            合作伙伴信息待更新，敬请期待
          </p>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 羞羞动漫在线 - 蜜桃动漫在线高清播放平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">回到顶部</a>
            <a href="#faq" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}